import React from 'react'
import ReactDom from 'react-dom';

const MODAL_STYLES = {
    position: "fixed",
    top: "50%",
    left: "50%",
    backgroundColor: "crimson",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
    height: "90%",
    width: "90%",
}

const OVERLAY_STYLES = {
    position: "fixed",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    zIndex: 1000,
}

const CLOSE_BUTTON_STYLES = {
    position: "absolute",
    top: "10px",
    right: "10px",
    background: "none",
    border: "none",
    color: "white",
    fontSize: "24px",
    cursor: "pointer",
    outline: "none",
    transition: "color 0.3s ease",
}

const Modal = ({ children, onClose }) => {
    return ReactDom.createPortal(
        <>
            <div style={OVERLAY_STYLES}>
                <div style={MODAL_STYLES}>
                    <button style={CLOSE_BUTTON_STYLES} onClick={onClose}>
                        &times;
                    </button>
                    {children}
                </div>
            </div >
        </>,
        document.getElementById("cart-root")
    )
}

export default Modal;
